import React from 'react';
import { AdminBreadcrumb, type BreadcrumbItem } from '../admin/AdminBreadcrumb';

/** Shared admin authoring header: context on the left, compact actions on the right. */
export function AuthoringHeader({
  title,
  breadcrumbs,
  actions,
  busy = false,
}: {
  title: string;
  breadcrumbs: BreadcrumbItem[];
  actions?: React.ReactNode;
  busy?: boolean;
}) {
  return (
    <div className="border-b border-border bg-background/95 backdrop-blur-sm sticky top-16 md:top-0 z-10">
      <div className="container mx-auto px-4 py-3 relative">
        <div className="flex items-center justify-between gap-4 min-h-[36px]">
          <h1 className="text-xl font-bold text-foreground truncate">{title}</h1>
          {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
        </div>
        <div inert={busy}>
          <AdminBreadcrumb items={breadcrumbs} />
        </div>
      </div>
    </div>
  );
}
